import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'

const StyledProgressBar = styled(LinearProgress)`
  border-radius: 5px;
  height: 25px;
`

const ProfileStrengthBar = ({ value, label }) => {
  return (
    <Box mt={5}>
      <Typography variant="body1" gutterBottom>
        Profile Strength
      </Typography>
      <StyledProgressBar variant="determinate" value={value ? value : 0} />
      {/* TODO: remove font-size property after designsers provide global style */}
      <Box mt={1} fontSize={12}>
        {label}
      </Box>
    </Box>
  )
}

export default ProfileStrengthBar
